import * as React from 'react'
const SvgLineHappy2 = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || 24}
    height={props.size || 24}
    fill="none"
    {...props}
  >
    <g transform={`scale(${(props.size || 24) / 24})`}>
      <path
        stroke="#8E8E95"
        strokeLinecap="round"
        strokeWidth={1.5}
        d="M9 16c.85.63 1.885 1 3 1s2.15-.37 3-1"
      />
      <path
        fill="#8E8E95"
        d="M15 12c.552 0 1-.672 1-1.5S15.552 9 15 9s-1 .672-1 1.5.448 1.5 1 1.5M9 12c.552 0 1-.672 1-1.5S9.552 9 9 9s-1 .672-1 1.5.448 1.5 1 1.5"
      />
      <path
        stroke="#8E8E95"
        strokeWidth={1.5}
        d="M3.353 8.95A7.51 7.51 0 0 1 8.95 3.353c2.006-.47 4.094-.47 6.1 0a7.51 7.51 0 0 1 5.597 5.597c.47 2.006.47 4.094 0 6.1a7.51 7.51 0 0 1-5.597 5.597c-2.006.47-4.094.47-6.1 0a7.51 7.51 0 0 1-5.597-5.597 13.35 13.35 0 0 1 0-6.1Z"
      />
    </g>
  </svg>
)
export default SvgLineHappy2
